$(document).ready(function () {
	$('[data-form-trigger]').change(function () {
		var formId = $(this).data('form-trigger');
		$form = $('#'+formId);
		console.log(formId)
		$form.submit();
	});
});